type DocumentVersion = { key: string; kind?: string; createdAt?: string | number | Date | null };

/** Display order only; retain provider order when chronology is unknown or tied. */
export function orderDocumentVersions<T extends DocumentVersion>(versions: readonly T[]): T[] {
  const timestamp = (version: T) => {
    const value = version.createdAt;
    if (value === null || value === undefined || value === '') return -Infinity;
    const time = value instanceof Date ? value.getTime() : new Date(value).getTime();
    return Number.isFinite(time) ? time : -Infinity;
  };
  const original = (version: T) => version.key === 'original' || version.kind === 'original';
  return [...versions].sort((left, right) => {
    if (original(left) !== original(right)) return original(left) ? 1 : -1;
    const leftTime = timestamp(left), rightTime = timestamp(right);
    return leftTime === rightTime ? 0 : leftTime > rightTime ? -1 : 1;
  });
}
